import { type ObjectValuesUnionType } from '../../../../utils/typing';

export const KLStateActionTypes = Object.freeze({
  UPDATE_KL_STATE: 'KOH-LANTA:UPDATE_STATE',
  SKIP_CURRENT_KL_TMP_NOTIFICATION: 'KOH_LANTA:SKIP_CURRENT_TMP_NOTIFICATION',
  SKIP_ALL_KL_TMP_NOTIFICATIONS: 'KOH_LANTA:SKIP_ALL_TMP_NOTIFICATIONS',
  FLUSH_KL_NOTIFICATIONS: 'KOH_LANTA:FLUSH_NOTIFICATIONS',
  RESTART_KL_ADVENTURE: 'KOH_LANTA:RESTART_ADVENTURE',
  REVIEW_KL_ADVENTURE: 'KOH_LANTA:REVIEW_ADVENTURE',
  FILL_TEMPORARY_KL_NOTIFICATIONS: 'KOH_LANTA:FILL_TEMPORARY_NOTIFICATIONS',
  SET_KL_ORIENTATION_PAGINATION_INDEX: 'KOH_LANTA:SET_ORIENTATION_PAGINATION_INDEX',
  SET_KL_HOME_VISITED_INDEX: 'KOH_LANTA:SET_HOME_VISITED_INDEX',
});

export type KLStateActionType = ObjectValuesUnionType<typeof KLStateActionTypes>;
